import {
  composeLoggers,
  createConsoleLogger,
  createSentryLogger,
  decorateLoggerLevel,
  LOG_LEVELS,
} from '@orionprotocol/logger';

const levelDecorator = decorateLoggerLevel(LOG_LEVELS.ERROR);
const consoleLogger = levelDecorator(createConsoleLogger());
const sentryLogger = createSentryLogger();

export const logger = composeLoggers([consoleLogger, sentryLogger]);
